(() => {
  if (window.pudelCartActionsReady) return;
  window.pudelCartActionsReady = true;
  const toast = document.createElement('div');
  toast.id = 'pudel-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.setAttribute('aria-atomic', 'true');
  document.body.appendChild(toast);
  const style = document.createElement('style');
  style.textContent = `
    #pudel-toast { position:fixed; bottom:max(24px,env(safe-area-inset-bottom)); left:50%; transform:translate(-50%,calc(100% + 60px)); z-index:10000; padding:16px 24px; border:1px solid var(--stone,#F5F2EE); border-radius:6px; background:var(--charcoal,#164E46); color:var(--stone,#F5F2EE); box-shadow:0 8px 30px #0003; font:500 16px var(--pudel-sans,'DM Sans',sans-serif); transition:transform 300ms ease; pointer-events:none; max-width:calc(100vw - 32px); text-align:center; }
    #pudel-toast.pudel-toast--visible { transform:translate(-50%,0); }
    .pudel-cart-action-error { color:var(--charcoal,#164E46); font-size:14px; margin:8px 0; }
    @media(prefers-reduced-motion:reduce) { #pudel-toast { transition:none; } }
  `;
  document.head.appendChild(style);
  let hideTimer;
  function announce() {
    clearTimeout(hideTimer);
    toast.textContent = 'Added to cart';
    toast.classList.add('pudel-toast--visible');
    hideTimer = setTimeout(() => toast.classList.remove('pudel-toast--visible'), 3300);
  }
  const pending = new WeakSet();
  let queue = Promise.resolve();
  async function add(form, button, body, error) {
    let added = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) throw new Error('The cart is unavailable. Please refresh the page and try again.');
      const sections = drawer.getSectionsToRender().map(section => section.id);
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname);
      const base = window.routes?.cart_add_url || '/cart/add';
      const url = base.endsWith('.js') ? base : base + '.js';
      const response = await fetch(url, {
        method:'POST',
        headers:{ Accept:'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      }
      added = true;
      announce();
      if (!result.sections || sections.some(id => !result.sections[id])) {
        const refresh = await fetch(window.location.pathname + '?sections=' + sections.join(','), { headers:{Accept:'application/json'} });
        if (!refresh.ok) throw new Error('Cart refresh failed');
        result.sections = await refresh.json();
        if (sections.some(id => !result.sections[id])) throw new Error('Cart refresh failed');
      }
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(button || document.activeElement);
      drawer.renderContents(result);
      document.dispatchEvent(new CustomEvent('pudel:cart-added', { detail:result }));
    } catch (failure) {
      error.textContent = added
        ? 'Your item was added, but the cart could not refresh. Please refresh the page to view it.'
        : failure.message || 'Unable to confirm this addition. Please check your cart before trying again.';
      error.hidden = false;
    } finally {
      pending.delete(form);
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (pending.has(form) || button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    const body = new FormData(form);
    if (!body.get('id') && !body.get('items[0][id]')) return;
    let error = form.querySelector('.pudel-cart-action-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'pudel-cart-action-error';
      error.setAttribute('role','alert');
      form.appendChild(error);
    }
    error.hidden = true;
    pending.add(form);
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy','true');
    }
    queue = queue.then(() => add(form, button, body, error));
  }, true);
})();
